import apiClient from '../axiosConfig';
import { components } from '../types/openapi';

// Tipos del OpenAPI
type AccessResponse = components['schemas']['AccessResponse'];
type AccessResponseWithUser = components['schemas']['AccessResponseWithUser'];
type PaginationAccessResponseWithUser = components['schemas']['Pagination_AccessResponseWithUser_'];
type PaginationAccessResponse = components['schemas']['Pagination_AccessResponse_'];

/**
 * Servicio de gestión de historial de acceso
 * Maneja todas las operaciones relacionadas con el historial de acceso de usuarios
 * Basado en los endpoints del OpenAPI
 */
class AccessService {
  /**
   * Obtener lista de accesos de usuarios
   * GET /api/auth/access
   * Solo para administradores
   */
  async getAccessHistory(params?: {
    limit?: number;
    username?: string;
  }): Promise<AccessResponseWithUser[]> {
    const response = await apiClient.get<AccessResponseWithUser[]>('/auth/access', { params });
    return response.data;
  }

  /**
   * Obtener accesos con paginación
   * GET /api/auth/access/pagination
   * Solo para administradores
   */
  async getAccessHistoryPaginated(params?: {
    page?: number;
    limit?: number;
    username?: string;
  }): Promise<PaginationAccessResponseWithUser> {
    const response = await apiClient.get<PaginationAccessResponseWithUser>('/auth/access/pagination', { params });
    return response.data;
  }

  /**
   * Obtener accesos de un usuario específico
   * GET /api/auth/access/{user_id}
   * Solo para administradores
   */
  async getAccessHistoryByUserId(userId: number): Promise<AccessResponse[]> {
    const response = await apiClient.get<AccessResponse[]>(`/auth/access/${userId}`);
    return response.data;
  }

  /**
   * Obtener accesos de un usuario específico con paginación
   * GET /api/auth/access/pagination/{user_id}
   * Solo para administradores
   */
  async getAccessHistoryByUserIdPaginated(params: {
    userId: number;
    page?: number;
    limit?: number;
  }): Promise<PaginationAccessResponse> {
    const response = await apiClient.get<PaginationAccessResponse>(
      `/auth/access/pagination/${params.userId}`,
      { params: { page: params.page, limit: params.limit } }
    );
    return response.data;
  }
}

export default new AccessService();

